import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    directoryNav: {
        accessibility: string;
        hide: string;
        show: string;
    };
    directoryContent: {
        accessibility: string;
        hide: string;
        show: string;
    };
    details: {
        accessibility: string;
        hide: string;
        show: string;
    };
    ai: {
        /** Aria label for toggling AI panel */
        accessibility: string;
        /** Label when hiding AI panel */
        hide: string;
        /** Label when showing AI panel */
        show: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            directoryNav: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "shareBuilder.directoryNav.accessibility?c=1bazrwnmy8ccb", defaultMessage: "Toggle the Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "shareBuilder.directoryNav.hide?c=lntz05bdbtl4", defaultMessage: "Hide Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "shareBuilder.directoryNav.show?c=9rg4whmyumvu", defaultMessage: "Show Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            directoryContent: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "shareBuilder.directoryContent.accessibility?c=43rs5ppxxybn", defaultMessage: "Toggle the Share Preview" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "shareBuilder.directoryContent.hide?c=2xwh2zrkxr5nx", defaultMessage: "Hide the Share Preview" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "shareBuilder.directoryContent.show?c=m115o4gd6i7s", defaultMessage: "Show the Share Preview" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            details: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "shareBuilder.details.accessibility?c=190q4ea2i1ne2", defaultMessage: "Toggle the asset Info" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "shareBuilder.details.hide?c=1jj9k48hksw7v", defaultMessage: "Hide Asset Info" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "shareBuilder.details.show?c=p6b76q673edj", defaultMessage: "Show Asset Info" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** AI panel toggle labels */
            ai: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Aria label for toggling AI panel */
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "shareBuilder.ai.accessibility?c=1umjiqoqq0dlm", defaultMessage: "Toggle the AI Panel" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when hiding AI panel */
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "shareBuilder.ai.hide?c=10ebb25ywjma3", defaultMessage: "Hide AI Panel" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when showing AI panel */
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "shareBuilder.ai.show?c=2gqg8jp2a38j8", defaultMessage: "Show AI Panel" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
